module.exports = __webpack_public_path__ + "static/media/pawritten-bold.e2dcf577.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pawritten-bold.woff
// module id = ./src/assets/fonts/pawritten-bold.woff
// module chunks = 0